import serviceAxios from "../index";

/**
 * 用户相关api
 */

/* 获取新闻相关列表 */
export function newsListApi(params) {
	return serviceAxios({
		url: '/api/news/list',
		method: 'get',
		params
	})
}

/* 获取新闻咨询详情 */
export function newsDetailApi(params) {
	return serviceAxios({
		url: '/api/news/detail',
		method: 'get',
		params
	})
}

/* 轮播图 */
export function swiperApi(params) {
	return serviceAxios({
		url: '/api/base/swiper',
		method: 'get',
		params
	})
}

// /* 设备列表 */
// export function equipmentListApi(params) {
// 	return serviceAxios({
// 		url: '/api/equipment/list',
// 		method: 'get',
// 		params
// 	})
// }

/* 商品列表 */
export function equipmentListApi(params) {
	return serviceAxios({
		url: '/api/tArchive/list',
		method: 'get',
		params
	})
}


/* 设备类型 */
export function equipmentTypeApi(id) {
	return serviceAxios({
		url: `/api/system/dict/data/${id}`,
		method: 'get',

	})
}

// /* 设备详细信息 */
// export function equipmentDetailApi(params) {
// 	return serviceAxios({
// 		url: '/api/equipment/detail',
// 		method: 'get',
// 		params
// 	})
// }
/* 设备详细信息 */
export function equipmentDetailApi(id) {
	return serviceAxios({
		url: `/api/tArchive/getInfoDetail/${id}`,
		method: 'get',
	})
}

/* 相似公司列表 */
export function recommendCompanyListApi(params) {
	return serviceAxios({
		url: '/api/master/recommendCompanyList',
		method: 'get',
		params
	})
}

/* 电工列表 */
export function electricianListApi(params) {
	return serviceAxios({
		url: '/api/master/ordinaryUserList',
		method: 'get',
		params
	})
}

//获取电工详情
export function electricianDetailApi(params) {
	return serviceAxios({
		url: '/api/master/ordinaryUserDetail',
		method: 'get',
		params
	})
}

//创建订单
export function addOrderApi(data) {
	return serviceAxios({
		url: '/api/order/add',
		method: 'post',
		data
	})
}

export function updateElectOrder(data){
	return serviceAxios({
		url: '/api/Master/updateElectOrder',
		method: 'post',
		data
	})
}

//订单列表
export function orderListApi(data) {
	return serviceAxios({
		url: '/api/tOrder/list',
		method: 'post',
		data
	})
}

//删除订单
export function orderDelApi(params) {
	return serviceAxios({
		url: '/api/order/delOrder',
		method: 'get',
		params
	})
}

//订单详情
export function orderDetailApi(params) {
	return serviceAxios({
		url: '/api/order/getDetail',
		method: 'get',
		params
	})
}

//地址列表
export function adderssList(params) {
	return serviceAxios({
		url: '/api/master/adderssList',
		method: 'get',
		params
	})
}

// 发布申请
export function lanuch_application(data) {
	return serviceAxios({
		url: '/api/electicianOrder/add',
		method: 'post',
		data
	})
}

// 获取电工信息
export function getEleInfo(params) {
	return serviceAxios({
		url: '/api/master/ordinaryUserDetail',
		method: 'get',
		params
	})
}


//电工订单列表
export function shareElecticianOrder(params) {
	return serviceAxios({
		url: '/api/electicianOrder/list',
		method: 'get',
		params
	})
}

//取消订单列表
export function delOrderShareElecticianOrder(params) {
	return serviceAxios({
		url: '/api/electicianOrder/delOrder',
		method: 'get',
		params
	})
}

//备选用电方案
export function beixuanApi(params) {
	return serviceAxios({
		url: '/api/equipment/bxList',
		method: 'get',
		params
	})
}

//添加购物车设备
export function addEquipmentApi(data) {
	return serviceAxios({
		url: '/api/tShoppingTrolley/addOrUpdate',
		method: 'post',
		data
	})
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
	return serviceAxios({
		url: '/api/system/dict/data/type/' + dictType,
		method: 'get'
	})
}

//转换购物车信息
export function swapUser(data) {
	return serviceAxios({
		url: "/api/tShoppingTrolley/swapUser",
		method: "post",
		data,
	});
}

//移除购物车设备
export function delEquipmentApi(data) {
	return serviceAxios({
		url: '/api/card/cardAddDel',
		method: 'post',
		data
	})
}

//设备列表
// export function carListApi(params) {
// 	return serviceAxios({
// 		url: '/api/card/cardList',
// 		method: 'get',
// 		params
// 	})
// }

//购物车列表
export function carListApi(params) {
	return serviceAxios({
		url: '/api/tShoppingTrolley/selectByUserIdGroupByCustomerName',
		method: 'get',
		params
	})
}

// 根据ID查询设备列表
export function getById(id) {
	return serviceAxios({
		url: `/api/tOrder/getById/${id}`,
		method: 'get',
	})
}

//删除设备列表
// export function deleteGoodApi(params) {
// 	return serviceAxios({
// 		url: '/api/card/delCard',
// 		method: 'get',
// 		params
// 	})
// }

//删除设备列表
export function deleteGoodApi(id) {
	return serviceAxios({
		url: `/api/tShoppingTrolley/delById/${id}`,
		method: 'get',
	})
}

//设备列表提交订单
export function addCarOrder(data) {
	return serviceAxios({
		url: '/api/card/insertCardOrder',
		method: 'post',
		data
	})
}


//设备列表修改订单
export function updateCarOrder(data) {
	return serviceAxios({
		url: '/api/card/updateCardOrder',
		method: 'post',
		data
	})
}

// //检出设备列表提交数据是否符合规则
// export function checkOrderApi(params) {
// 	return serviceAxios({
// 		url: '/api/card/check',
// 		method: 'get',
// 		params
// 	})
// }

//检出设备列表提交数据是否符合规则
export function applicationShop(data) {
	return serviceAxios({
		url: '/api/tShoppingTrolley/application',
		method: 'post',
		data
	})
}

//设备费用选择项
export function eqPriceListApi(params) {
	return serviceAxios({
		url: '/api/equipment/queryPrice',
		method: 'get',
		params
	})
}

//推荐电工
export function recommendElectricianListApi(params) {
	return serviceAxios({
		url: '/api/master/recommendElectricianList',
		method: 'get',
		params
	})
}

/**
 * 2023 修改
 */
// 新增 - 共享电工需求
export function addNeed(data) {
	return serviceAxios({
		url: '/api/system/need/addNeed',
		method: 'post',
		data
	})
}
// 修改 - 共享电工需求
export function editNeed(data) {
	return serviceAxios({
		url: '/api/system/need/editNeed',
		method: 'post',
		data
	})
}
// 客户查看自己订单列表
export function getTobeReleased(data) {
	return serviceAxios({
		url: '/api/system/need/getTobeReleased',
		method: 'get',
		params: data
	})
}
// 删除 需求（待发布）
export function deleteById(data) {
	return serviceAxios({
		url: '/api/system/need/deleteById/'+data,
		method: 'get'
	})
}
